import { memo } from 'react';
import PropTypes from 'prop-types';
import { BolDocumentIcon, VehicleNumberIcon } from 'components/icons/OcrValueSourceIcons';
import styles from './OcrVerificationChip.module.css';

const UNKNOWN = 'unknown';

/**
 * The OCR verification of a field (Figma 16362:41459): BOL document value = or != the compared vehicle value. Green
 * only for a match; a mismatch and an incomplete verification are red, so unknown never looks verified.
 */
function OcrVerificationChip({ chip, className }) {
    const { bolValue, vehicleValue, tone } = chip;
    const isMatch = tone === 'match';
    const bolText = bolValue ?? UNKNOWN;
    const vehicleText = vehicleValue ?? UNKNOWN;
    const description = `BOL document ${bolText} ${isMatch ? 'matches' : 'does not match'} number on vehicle ${vehicleText}`;

    return (
        <span
            className={`${styles.chip} ${isMatch ? styles['chip--match'] : styles['chip--mismatch']}${className ? ` ${className}` : ''}`}
            role="status"
            aria-label={description}
            title={description}
        >
            <span className={styles.value}>
                <span className={styles['value-text']}>{bolText}</span>
                <BolDocumentIcon />
            </span>
            <span className={styles.relation} aria-hidden="true">
                {isMatch ? '=' : '≠'}
            </span>
            <span className={styles.value}>
                <span className={styles['value-text']}>{vehicleText}</span>
                <VehicleNumberIcon />
            </span>
        </span>
    );
}

OcrVerificationChip.propTypes = {
    chip: PropTypes.shape({
        bolValue: PropTypes.string,
        vehicleValue: PropTypes.string,
        tone: PropTypes.oneOf(['match', 'mismatch']).isRequired,
    }).isRequired,
    className: PropTypes.string,
};

export default memo(OcrVerificationChip);
